module.exports = __webpack_public_path__ + "assets/img/word-sound-gif.85a1f269.gif";